import React, { useEffect, useState } from "react";
import { userManager } from "./oidc";
import LoginPage from "../pages/LoginPage";

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState({
    loading: true,
    authenticated: false,
  });

  useEffect(() => {
    (async () => {
      const user = await userManager.getUser();
      setState({
        loading: false,
        authenticated: !!user && !user.expired,
      });
    })();
  }, []);

  if (state.loading) {
    return null; // oder Loader
  }

  if (!state.authenticated) {
    return <LoginPage />;
  }

  return children;
}
